// Arpeggiator panel — turns the bell into a note-at-a-time echo of whatever
// chord the pad holds in each bar, walked in one of ARP_PATTERNS' orders.

import React from "react";
import { cn } from "../../lib/utils";
import { ARP_PATTERNS } from "../../lib/starterTape";

export default function ArpPanel({
  pattern,
  onPatternChange,
  onArpeggiate,
  disabled,
}) {
  return (
    <div className="mb-4 rounded-xl border border-zinc-800 bg-zinc-900/60 p-3">
      <p className="text-sm font-semibold text-zinc-100">Arpeggiator</p>
      <p className="mb-2 text-xs text-zinc-500">
        Plays each bar's chord one note at a time on the bell.
      </p>
      <div className="flex flex-wrap items-center gap-2">
        <div
          className="flex flex-wrap items-center gap-1 rounded-lg border border-zinc-800 p-1"
          role="group"
          aria-label="Arpeggio pattern"
        >
          {Object.entries(ARP_PATTERNS).map(([id, def]) => (
            <button
              key={id}
              type="button"
              onClick={() => onPatternChange(id)}
              aria-pressed={pattern === id}
              className={cn(
                "rounded-md px-2.5 py-1 text-sm",
                pattern === id
                  ? "bg-zinc-100 text-zinc-900"
                  : "text-zinc-400 hover:bg-zinc-800"
              )}
            >
              {def.name}
            </button>
          ))}
        </div>
        <button
          type="button"
          onClick={onArpeggiate}
          disabled={disabled}
          className={cn(
            "rounded-lg px-4 py-2 text-sm font-semibold transition-colors",
            "bg-amber-300 text-zinc-900 hover:bg-amber-200",
            disabled && "cursor-not-allowed opacity-50"
          )}
        >
          Arpeggiate chords into the bell
        </button>
      </div>
    </div>
  );
}
